import { DataContext, IDataContextProps } from '../context';
import { useContext } from 'react';

export const useDataContext = (): IDataContextProps => {
    const context = useContext<IDataContextProps | null>(DataContext);
    if (context === null) {
        throw new Error('Component must be wrapped with <DataGridProvider>');
    }
    return context;
};